import Reveal from '@/components/base/Reveal';
import SectionLabel from '@/components/base/SectionLabel';
import { galleryItems } from '../data';

export default function Gallery() {
  return (
    <section id="gallery" className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-xl">
            <SectionLabel>Real-World Gallery</SectionLabel>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl leading-[1.12] font-medium text-foreground-950">
              Inside SRM Textiles
            </h2>
          </div>
          <p className="max-w-sm text-[15px] leading-relaxed text-foreground-700">
            A glimpse of the collection, the market, the textiles and the people behind a
            genuine UK textile business.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {galleryItems.map((item, i) => (
            <Reveal
              key={item.label}
              delay={(i % 3) * 80}
              className={item.tall ? 'row-span-2' : ''}
            >
              <figure className="group img-zoom relative rounded-lg overflow-hidden h-full">
                <img
                  src={item.image}
                  alt={`${item.label} — authentic photograph from SRM Textiles market business`}
                  className={`w-full object-cover object-top ${item.tall ? 'h-full min-h-[320px]' : 'h-44 md:h-56'}`}
                />
                <figcaption className="absolute inset-0 flex items-end bg-gradient-to-t from-black/55 via-transparent to-transparent p-5">
                  <span className="text-[11px] font-semibold uppercase tracking-[0.26em] text-background-50">
                    {item.label}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}